import * as React from "react";

import {
  Box,
  Typography,
  PlayCircle,
  PauseCircle,
  Button,
} from "mpulse-design-system";
import { styled } from "@mui/material";

import { useAudio } from "../../hooks/useAudio";
import { formatAudioDuration } from "../../utils/utils";

const AudioPlayer = ({ url, duration }) => {
  const [playing, setPlaying] = React.useState(false),
    { play, pause } = useAudio();

  const handleAudioPlayer = (e) => {
    if (!playing) {
      play(url, setPlaying);
      setPlaying(true);
    } else {
      pause(setPlaying);
      setPlaying(false);
    }
  };
  return (
    <StyledBox>
      {playing ? (
        <Button
          onClick={handleAudioPlayer}
          style={{
            maxWidth: "30px",
            maxHeight: "30px",
            minWidth: "30px",
            minHeight: "30px",
          }}
        >
          <PauseCircle color="primary" sx={{ cursor: "pointer" }} />
        </Button>
      ) : (
        <Button
          onClick={handleAudioPlayer}
          style={{
            maxWidth: "30px",
            maxHeight: "30px",
            minWidth: "30px",
            minHeight: "30px",
          }}
        >
          <PlayCircle color="primary" sx={{ cursor: "pointer" }} />
        </Button>
      )}
      <Typography
        color="textPrimary"
        sx={{ paddingLeft: (theme) => theme.spacing(2), paddingTop: "5px" }}
      >
        {formatAudioDuration(duration)}
      </Typography>
    </StyledBox>
  );
};

const StyledBox = styled(Box)(() => ({
  display: "inline-flex",
}));

export default AudioPlayer;
